import LC from "@/repositories/lisacomunica/lc";

export default {
  // eMessage
  credit_show() {
    let resource = `/eMessage/credit`;
    return LC.post(`${resource}`);
  },
};
